// All user-facing strings live here. Keys are dotted paths grouped by
// surface. Adding a new screen? Add its strings here too — the t() helper
// will TypeScript-error on unknown keys.

export const es = {
  common: {
    loading:      "Cargando…",
    saving:       "Guardando…",
    cancel:       "Cancelar",
    save:         "Guardar",
    delete:       "Borrar",
    edit:         "Editar",
    create:       "Crear",
    add:          "Agregar",
    remove:       "Quitar",
    reload:       "Recargar",
    shutdown:     "Apagar",
    enabled:      "Habilitado",
    disabled:     "Deshabilitado",
    enable:       "Habilitar",
    disable:      "Deshabilitar",
    open:         "Abrir",
    close:        "Cerrar",
    confirm:      "Confirmar",
    optional:     "(opcional)",
    none:         "—",
    none_yet:     "Todavía no hay nada.",
    error_generic:"Algo salió mal.",
    search:       "Buscar",
    new:          "Nuevo",
    restore:      "Restaurar",
    show:         "Mostrar",
    hide:         "Ocultar",
    copy:         "Copiar",
    run:          "Ejecutar",
    refresh:      "Refrescar",
    view_all:     "Ver todo",
    saved:        "Guardado.",
    deleted:      "Eliminado.",
    pager_prev:   "Anterior",
    pager_next:   "Siguiente",
    pager_page:   "Página {page} de {total}",
    pager_range:  "{from}–{to} de {total}",
    pager_per_page:"Por página",
  },
  daemon: {
    connecting:    "Conectando con el daemon…",
    unreachable:   "No pude llegar al daemon en localhost:7430.",
    unreachable_hint:"Arrancá APX con `apx daemon start` y refrescá.",
    version:       "Versión",
    uptime:        "Uptime",
    status:        "Status",
    running:       "running",
    down:          "down",
    reload_hint:   "POST /admin/reload — relee ~/.apx/config.json sin reiniciar.",
    shutdown_confirm: "¿Apagar el daemon? Las próximas requests fallarán hasta levantarlo de nuevo.",
    shutdown_done: "Daemon detenido.",
  },
  pairing: {
    title:        "Vincular este equipo",
    subtitle:     "Estás entrando desde fuera de esta máquina. Por seguridad, vinculá este navegador con un código de pairing.",
    steps_title:  "Cómo obtener el código",
    step_1:       "En la PC donde corre APX, abrí una terminal.",
    step_2:       "Ejecutá `apx pair` (o escaneá el QR con APX Deck).",
    step_3:       "Copiá el código que aparece debajo del QR y pegalo acá.",
    code_label:   "Código de pairing",
    code_ph:      "p. ej. 7f3a1c9e-…",
    label_label:  "Nombre de este equipo",
    label_ph:     "p. ej. Notebook del living",
    submit:       "Vincular",
    linking:      "Vinculando…",
    success:      "Equipo vinculado ✓",
    err_required: "Pegá el código de pairing.",
    err_expired:  "El código expiró. Volvé a correr `apx pair` y probá de nuevo.",
    err_unknown:  "Código desconocido o ya usado. Generá uno nuevo con `apx pair`.",
    err_generic:  "No se pudo vincular. Revisá el código e intentá otra vez.",
    revoke_hint:  "Podés revocar este equipo cuando quieras desde Settings o con `apx pair revoke`.",
  },
  nav: {
    apx_admin:    "APX",
    settings:     "Settings",
    project:      "Proyecto",
    add_project:  "Agregar proyecto",
    all_projects:      "Todos los proyectos",
    more_projects:     "{count} más",
    collapse_projects: "Ocultar proyectos",
    expand_projects:   "Mostrar proyectos",
    modules: {
      voice:   "Voces",
      desktop: "Escritorio",
      deck:  "Deck",
      code:  "Code",
      web:   "Web",
    },
  },
  topbar: {
    breadcrumb_root:     "APX",
    breadcrumb_settings: "APX › Settings",
    breadcrumb_project:  "APX › Proyecto",
    breadcrumb_base:     "Base",
    breadcrumb_projects: "Proyectos",
    light:               "Cambiar a claro",
    dark:                "Cambiar a oscuro",
    lang_toggle:         "Idioma",
  },
  admin: {
    title:             "APX",
    subtitle:          "Panel general. Configuración global, canales y proyectos.",
    engines_title:     "Engines",
    engines_subtitle:  "Adaptadores LLM disponibles. Las API keys viven en ~/.apx/config.json.",
    telegram_title:    "Telegram",
    telegram_subtitle: "Canales configurados. Cada uno puede estar pineado a un proyecto.",
    telegram_polling_on:  "Polling activo",
    telegram_polling_off: "Deshabilitado",
    telegram_add_channel: "Canal",
    telegram_send_test:   "Probar",
    telegram_send_test_title: "Enviar a",
    telegram_default_message: "Mensaje de prueba desde el panel de APX ✅",
    projects_title:    "Proyectos registrados",
    projects_subtitle: "Click en un proyecto para abrir su panel.",
    unregister:        "Desregistrar",
    unregister_confirm:"¿Quitar {label} de APX? La carpeta no se borra; sólo se desregistra.",
    reload_success:    "Config recargada.",
    telegram_polling_started: "Polling iniciado.",
    telegram_polling_stopped: "Polling detenido.",
    telegram_channel_removed: "Canal eliminado.",
    agents_badge:      "agents",
    engine_badge:      "sí",
    engine_badge_no:   "no",
    base_label:        "Base",
  },
  add_project: {
    title:       "Agregar proyecto",
    subtitle:    "APX indexará .apc/, agents y AGENTS.md en esa carpeta.",
    path_label:  "Ruta absoluta",
    path_hint:   "Equivalente a apx project add /ruta/al/proyecto",
    path_placeholder: "/Volumes/SSDT7Shield/proyectos_varios/mi-proyecto",
    register:    "Registrar",
    path_required: "Ruta requerida.",
    registered:  "Proyecto #{id} registrado.",
    search_btn:  "Buscar",
    picker_prompt: "Elegí la carpeta del proyecto",
    browser_unavailable: "Explorador no disponible hasta reiniciar daemon. Pegá ruta manual.",
    no_folders:  "Sin carpetas.",
  },
  settings: {
    title:       "Settings",
    subtitle:    "Preferencias del panel + diagnóstico del daemon local.",
    appearance:  "Apariencia",
    light_mode:  "Claro",
    dark_mode:   "Oscuro",
    system_mode: "Sistema",
    language:    "Idioma",
    daemon:      "Daemon",
    daemon_sub:  "Estado del proceso local que sirve esta web y orquesta los agentes.",
    engines:     "Engines disponibles",
    engines_sub: "Adaptadores LLM compilados con el daemon.",
    token:       "Token para esta sesión",
    token_sub:   "Si esta web no logró auto-cargar el token, pegalo acá.",
    token_active:"(ya hay token activo)",
    token_paste: "Pegá el bearer del daemon",
    token_saved: "Token guardado.",
    devices:     "Dispositivos pareados",
    devices_sub: "GET /pair/list. Revocar invalida ese bearer en el daemon.",
    devices_empty: "No hay clientes pareados todavía.",
    devices_revoke_confirm: "Revocar cliente {id}?",
    devices_revoke_success: "Cliente revocado.",
    devices_pair_btn:   "Vincular dispositivo",
    devices_pair_title: "Vincular dispositivo",
    devices_pair_desc:  "Escaneá el QR con la cámara del celu para entrar directo, o pegá el código en la otra PC.",
    devices_pair_scan:  "Escaneá con la cámara del teléfono — te abre la web ya vinculada.",
    devices_pair_code:  "O pegá este código en la pantalla de pairing:",
    devices_pair_url:   "URL de acceso",
    devices_pair_link:  "O copiá este link y abrilo en el otro dispositivo (entra solo):",
    devices_pair_copy:   "Copiar",
    devices_pair_copied: "Link copiado al portapapeles.",
    devices_pair_copied_code: "Código copiado.",
    devices_pair_expires: "Expira en {s}s",
    devices_pair_expired: "El código expiró.",
    devices_pair_regen:  "Generar otro",
    devices_pair_waiting: "Esperando que el dispositivo confirme…",
    devices_pair_done:   "Dispositivo vinculado ✓",
    devices_pair_localhost_only: "Solo se pueden generar códigos desde la PC del daemon (localhost).",
    devices_last_seen:   "visto:",
    devices_never:       "nunca",
    devices_revoke:      "Revocar",
    account_section:     "Cuenta",
    agents_section:      "Agentes & modelos",
    channels_section:    "Canales & dispositivos",
    modules_section:     "Módulos",
    advanced_section:    "Avanzado",

    tabs: {
      identity: "Identidad",
      super_agent: "Super-agente",
      engines: "Engines & modelos",
      telegram: "Telegram",
      devices: "Dispositivos",
      advanced: "Avanzado",
    },

    identity: {
      title: "Identidad",
      subtitle: "Datos del usuario. Configuración del agente va en Super-agente.",
      agent_name: "Nombre del agente",
      owner_name: "Tu nombre",
      personality: "Personalidad",
      owner_context: "Contexto del dueño",
      owner_context_hint: "Quién sos, en qué trabajás, qué le interesa al agente saber de vos.",
      language: "Idioma preferido",
      timezone: "Timezone (IANA)",
      timezone_hint: "Detectado automáticamente — buscá para cambiar.",
      saved: "Identidad guardada.",
    },

    super_agent: {
      title: "Super-agente",
      subtitle: "Personalidad, modelo, prompt y modos del super-agente.",
      personality: "Personalidad",
      model: "Modelo activo",
      model_hint: "Ej: anthropic:claude-sonnet-4.5, ollama:gemma2:9b",
      permission_mode: "Permission mode",
      system: "Prompt extra (system)",
      system_hint: "Texto que se prepende al system prompt base.",
      system_ph: "(Vacío = se usa el prompt base de core/agent/prompts/super-agent-base.md)",
      fallback_title: "Fallback chain",
      fallback_hint: "Si el modelo activo falla, prueba estos en orden.",
      fallback_add: "Agregar modelo a la cadena",
      saved: "Super-agente guardado.",
      enabled_label: "Super-agente habilitado",
      model_active:  "Modelo activo (router)",
      model_configure: "Configurar en Modelos",
      behavior_subtitle: "Comportamiento del super-agente. El modelo y la cadena de fallback se configuran en el Router de modelos.",
    },

    engines_keys: {
      title: "API keys de modelos",
      subtitle: "Cada engine guarda su key en ~/.apx/config.json. Los valores ya seteados muestran sufijo seguro.",
      ollama_url: "Ollama URL",
      ollama_hint: "Por defecto: http://127.0.0.1:11434",
      key_label: "API key",
      key_placeholder: "(no seteada)",
      clear: "Borrar key",
      saved: "Key guardada.",
      cleared: "Key borrada.",
    },

    telegram_global: {
      title: "Telegram (default)",
      subtitle: "Canal default — los proyectos pueden overridear con su propio canal.",
      bot_token: "Bot token",
      chat_id: "Chat ID por defecto",
      poll_interval: "Poll interval (ms)",
      respond_with_engine: "Respond with engine",
      enabled: "Polling habilitado",
      saved: "Telegram guardado.",
    },

    advanced: {
      title: "Avanzado",
      subtitle: "Editor raw del ~/.apx/config.json. Los secretos se ven *** set *** pero podés escribir uno nuevo.",
      write: "Aplicar cambios",
      written: "Config aplicada y daemon recargado.",
      reload_success: "Config recargada.",
    },
  },
  project: {
    not_found:          "Roby no encontró el proyecto {pid}: quizás se desregistró o el ID es incorrecto.",
    rebuild:            "Rebuild context",
    rebuild_done:       "Rebuild OK.",
    unregister_confirm: "¿Desregistrar {label}? La carpeta no se borra.",
    unregistered:       "Desregistrado.",
    base_subtitle:      "Espacio general · super-agente",

    danger: {
      title:                     "Zona peligrosa",
      subtitle:                  "Acciones que afectan el registro del proyecto en APX. No tocan archivos del repo.",
      rebuild_desc:              "Re-escanea .apc/, MCPs y agents y regenera el contexto del super-agente para este proyecto.",
      unregister_desc:           "Quita el proyecto del registry de APX. La carpeta del disco se mantiene intacta.",
      rebuild_confirm_title:     "Rebuild context",
      rebuild_confirm_desc:      "Regenerar contexto de {label}.",
      rebuild_long:              "Vuelve a leer la config APC, lista MCPs y agents disponibles, y reconstruye el system prompt del super-agente. Es seguro de correr — no borra nada. Usalo después de tocar .apc/ a mano o si los cambios no se reflejan.",
      unregister_confirm_title:  "Desregistrar proyecto",
      unregister_long:           "El proyecto deja de aparecer en `apx`. Los archivos del disco (.apc/, código, todo) se mantienen. Podés volver a registrarlo con `apx project register <path>`.",
    },

    nav: {
      overview: "Overview",
      chat:     "Chat",
      config:   "Config",
      telegram: "Telegram",
      agents:   "Agents",
      routines: "Rutinas",
      tasks:    "Tasks",
      mcps:     "MCPs",
      artifacts: "Artifacts",
      vars:     "Variables",
      logs:     "Logs",
      memories: "Memorias",
      structure: "Estructura",
      docs:     "Docs",
      files:    "Archivos",
    },

    sections: {
      workspace: "Workspace",
      content: "Contenido",
      automation: "Automatización",
      knowledge: "Conversaciones",
      config: "Config",
    },

    overview: {
      tasks_open: "Tasks abiertas",
      routines:   "Rutinas",
      routines_active: "Rutinas activas",
      agents:     "Agents",
      mcps:       "MCPs",
      artifacts:  "Artifacts",
      chat:       "Chat (super-agent)",
      chat_value: "abrir",
      roster:     "Equipo",
      no_agents:  "Todavía no hay agentes.",
      orchestrators: "Orquestadores",
      specialists: "Especialistas",
      recent_tasks: "Tasks recientes",
      no_activity: "No hay tasks abiertas.",
      brain_title: "Cerebro del equipo",
      brain_desc: "El mapa completo de agentes — los orquestadores en el núcleo y sus especialistas en racimo alrededor. Clic en un nodo para abrirlo.",
      brain_core: "Equipo",
    },

    artifacts: {
      title:    "Artifacts",
      subtitle: "Scripts y archivos reutilizables guardados en el proyecto. Los crean los agentes; podés verlos, ejecutarlos, renombrarlos o eliminarlos.",
    },

    chat: {
      title:       "Chat con agente",
      subtitle:    "Chat directo con el agente del proyecto.",
      live_title:  "Chat con {agent}",
      superagent_title:  "Chat con {persona}",
      superagent_subtitle: "Chat con {persona} — el super-agente APX. Puede usar tools (proyectos, tasks, mcps, agentes).",
      loaded_subtitle: "Conversación cargada con {slug}. Lo que mandes se agrega a este chat.",
      thread_subtitle: "Historial con {persona} en {channel}. Si respondés acá, la conversación sigue desde la web.",
      empty:       "Mandá un mensaje para arrancar la conversación.",
      placeholder: "Escribí algo y enter para enviar (shift+enter = nueva línea)",
      send:        "Enviar",
      stop:        "Stop",
      new_session: "Nueva sesión",
      delete:      "Borrar",
      delete_confirm_title: "Borrar chat",
      delete_confirm_desc:  "Esta acción no se puede deshacer. Se elimina para siempre el historial de este chat.",
      deleted:     "Chat borrado.",
      meta_created: "Creado {date} · {channel}",
      meta_new:     "Chat nuevo · {channel}",
      copy:        "copiar",
      copied:      "Copiado.",
      stopped_marker: " [detenido]",
      create_agent:   "Crear agente",
      create_agent_title: "Crear agente",
      create_agent_desc: "Necesario para iniciar chat en proyecto.",
      role_label:  "rol",
      model_label: "modelo",
      model_hint:  "ej. openai:gpt-5, groq:llama-3.3-70b-versatile",
      master_label: "Agente master",
      list: {
        title:         "Chats",
        new:           "Nuevo",
        search:        "Buscar chats…",
        all_agents:    "Todos los agentes",
        empty:         "No hay conversaciones todavía. Arrancá una desde la derecha.",
        count:         "{n} en total",
        pick_agent:    "Elegí un agente",
      },
    },

    tasks: {
      title:       "Tasks (TODOs)",
      subtitle:    "Append-only JSONL en ~/.apx/projects/<id>/tasks/.",
      add:         "agregar",
      add_label:   "Nueva task",
      add_placeholder: "ej. revisar bug del scroll",
      empty:       "No hay tasks {state}.",
      empty_open:  "No hay tasks abiertas.",
      created:     "Task creada.",
      create_error: "no pude crear la task",
      done:        "✓ done",
      drop:        "✗ drop",
      reopen:      "↻ reopen",
      due:         "vence",
      via:         "via",
      aria_done:   "marcar done",
      aria_drop:   "descartar task",
      aria_reopen: "reabrir task",
    },

    global_tasks: {
      title:       "Tasks (todos los proyectos)",
      subtitle:    "Tareas agregadas de todos los proyectos registrados.",
      empty:       "Sin tasks.",
      due:         "vence",
      go_project:  "Ir al proyecto",
    },

    routines: {
      title:       "Heartbeats / Routines",
      subtitle:    "Cron, every:Nm, once:ISO. Cada rutina dispara un agente o un shell.",
      empty:       "Sin rutinas. Creá una arriba.",
      new:         "nueva",
      new_btn:     "Nueva",
      delete_confirm: "Borrar rutina {name}?",
      delete_confirm_body: "Esta acción no se puede deshacer.",
      saved:       "Rutina guardada.",
      paused:      "pausada",
      next_run:    "próxima:",
      last_run:    "última:",
      enabled_hint: "Activa · corre según el intervalo",
      disabled_hint: "Pausada · solo con el botón Run",
      enabled_label: "Habilitada",
      new_title:   "Nueva rutina",
      edit_title:  "Editar {name}",
      dialog_desc: "Se guarda en .apc/routines.json. La rutina corre mientras el daemon está activo.",
      name_field:   "Nombre (name)",
      name_no_edit: "No se puede cambiar al editar.",
      kind_field:   "Acción (kind)",
      schedule_field: "Intervalo (schedule)",
      schedule_hint: "Elegí un preset o escribilo a mano. Manual = solo corre con el botón Run.",
      vars_title:   "Variables disponibles",
      what_happens: "Qué va a pasar",
      list_title:   "Rutinas",
      detail_empty: "Elegí una rutina de la lista.",
      edit_btn:     "Editar",
      edit_hint:    "Abrir el editor: tipo, intervalo, prompt, pre/post y variables.",
      block_pre:    "Pre-commands",
      block_post:   "Post-commands",
      block_prompt: "Prompt",
      block_text:   "Texto",
      block_command: "Comando",
      block_empty:  "(vacío)",
      runs_title:   "Ejecuciones",
      runs_empty:   "Sin ejecuciones todavía.",
      runs_close:   "Cerrar",
      runs_no_detail: "Sin más detalle.",
      runs_output:  "Salida",
      status_ok:    "ok",
      status_error: "error",
      status_skipped: "salteada",
      agent_field:  "Agente (spec.agent)",
      agent_hint:   "Quién ejecuta la rutina.",
      agent_loading: "cargando…",
      agent_pick:   "— elegí un agente —",
      prompt_exec:  "Prompt (spec.prompt)",
      prompt_exec_ph: "qué pendiente hay para hoy?",
      prompt_super: "Prompt (spec.prompt)",
      prompt_super_ph: "resumí el estado del proyecto",
      pre_field:    "Pre-commands (pre_commands)",
      pre_hint:     "Shell ANTES del prompt. Uno por línea.",
      post_field:   "Post-commands (post_commands)",
      post_hint:    "Shell DESPUÉS del prompt. Uno por línea.",
      tg_channel:   "Canal (spec.channel)",
      tg_chat_id:   "Chat ID (spec.chat_id)",
      tg_text:      "Mensaje de Telegram (spec.text)",
      tg_text_hint: "Mensaje fijo a enviar. No usa modelo.",
      shell_field:  "Comando (spec.command)",
      shell_hint:   "Corre tal cual en el shell. Sin prompt ni pre/post.",
      hb_channel:   "Canal (spec.channel)",
      hb_message:   "Mensaje (spec.message)",
      name_required: "name requerido",
      save_error:   "save falló",
      run_error:    "run falló",
      toggle_error: "toggle falló",
      delete_error: "delete falló",
      run_success:  "{name} disparada.",
      run_confirm:  "¿Ejecutar la rutina {name} ahora?",
      run_confirm_body: "Corre la acción una vez, sin esperar al horario.",
      running:      "Ejecutando…",
      delete_success: "borrada.",
    },

    agents: {
      title:       "Agents",
      subtitle:    "Definidos en .apc/agents/<slug>.md.",
      subtitle_full: "Definidos en .apc/agents/<slug>.md. La memoria runtime vive en ~/.apx/projects/<id>/agents/<slug>/.",
      empty:       "Sin agents. Agregá uno con <code>apx agent add</code> o el botón.",
      empty_text:  "Sin agents. Agregá uno con `apx agent add` o el botón de arriba.",
      new:         "Agente",
      created:     "Agent {slug} creado.",
      slug_invalid: "slug debe matchear /^[a-z][a-z0-9_-]*$/",
      hierarchy:   "Jerarquía",
      list_view:   "Lista",
      import:      "Importar",
      chat:        "Chat",
      view:        "Ver",
      orchestrator: "Orquestador",
      new_title:   "Nuevo agent",
      new_desc:    "POST /projects/:pid/agents — escribe .apc/agents/<slug>.md.",
      slug_label:  "slug",
      slug_ph:     "cody",
      role_label:  "role (opcional)",
      role_ph:     "code refactor",
      model_label: "model (opcional)",
      model_hint:  "ej. ollama:gemma2:9b, openai:gpt-4o-mini",
      lang_label:  "language (opcional)",
      desc_label:  "description (opcional)",
      desc_ph:     "Qué hace este agente…",
      skills_label: "skills (coma)",
      skills_ph:   "skill-a, skill-b",
      tools_label: "tools (coma)",
      tools_ph:    "tool-a, tool-b",
      parent_label: "reporta a (parent, opcional)",
      parent_hint: "Subagente de un orquestador.",
      none_parent: "— ninguno —",
      master_label: "Orquestador (master)",
      create_success: "Agent {slug} creado.",
      create_error: "create falló",
      import_title: "Importar del vault",
      import_desc: "Plantillas en ~/.apx/agents. Se registran en este proyecto (.apc/agents/<slug>.md).",
      import_empty: "Sin plantillas en el vault.",
      import_success: "Importado: {slug}",
      import_already: "ya está",
      import_btn:  "Importar",
    },

    agent_detail: {
      not_found:       "Agente no encontrado.",
      chat_btn:        "Chat con {slug}",
      reports_to:      "↳ reporta a",
      no_threads:      "Sin threads.",
      no_activity:     "Sin actividad registrada.",
      threads_recent:  "Threads recientes",
      subagents:       "Subagentes",
      subagents_desc:  "Agentes que reportan a este orquestador.",
      config_title:    "Configuración del agente",
      type_label:      "Tipología (type)",
      area_label:      "Área",
      area_hint:       "ej. operaciones, marketing",
      area_ph:         "operaciones",
      role_label:      "Role",
      parent_label:    "Reporta a (parent)",
      none_parent:     "— ninguno —",
      model_label:     "Modelo base",
      model_hint:      "Vacío = usa el modelo del Router (default). Setealo solo para forzar un modelo a este agente.",
      model_ph:        "(vacío = router default)",
      skills_label:    "Skills (coma)",
      bio_label:       "Bio / descripción",
      system_label:    "System prompt",
      system_hint:     "Define personalidad y comportamiento (cuerpo del AGENT.md).",
      master_label:    "Orquestador (master)",
      delete_btn:      "Borrar agente",
      save_btn:        "Guardar cambios",
      delete_confirm:  "Borrar el agente \"{slug}\"? Se elimina .apc/agents/{slug}.md y sus datos runtime locales.",
      update_success:  "Agente actualizado.",
      delete_success:  "Agente borrado.",
      tools_hint:      "Qué tools puede usar el agente. Tocá para activar/desactivar; o editá la lista abajo.",
      tools_custom_ph: "lista (coma): echo, http_fetch",
      memory_title:    "Memoria del agente",
      memory_empty:    "(memoria vacía)",
      memory_saved:    "Memoria guardada.",
      records_title:   "Records",
      records_desc:    "Log de actividad del agente (mensajes/acciones). Lo más nuevo primero.",
      sleep_title:     "Sleep / Heartbeat",
      sleep_desc:      "Estado de ejecución del agente, derivado de sus rutinas.",
      sleep_deep:      "Deep sleep · sin heartbeat",
      sleep_deep_desc: "Este agente no tiene ninguna rutina que lo dispare. No se ejecuta de forma autónoma; solo responde cuando lo invocás (chat / tarea).",
      brain_title:     "Brain",
      brain_desc:      "Grafo de relaciones reales del agente: memoria, threads, tasks, heartbeats y jerarquía. (primera versión — lo refinamos)",
      brain_empty:     "Aún no hay relaciones para graficar (sin memoria, threads, tasks ni rutinas).",
      msgs_count:      "msgs",
    },

    mcps: {
      title:       "MCP servers",
      subtitle:    "3 scopes: Runtime > Shared > Global. Conflictos arriba si los hay.",
      empty:       "Sin MCPs configurados.",
      new:         "MCP",
      delete_confirm: "Borrar MCP {name} de scope {scope}?",
      conflicts:   "⚠ Conflictos: {names}",
      conflict_detail: "{name} está definido en {winner} y {loser}. Se usa {winner}; {loser} queda ignorado.",
      new_title:   "Nuevo MCP",
      edit_title:  "Editar MCP",
      new_desc:    "Se guarda según el scope elegido. Los valores con ${var.X} se resuelven al arrancar el MCP.",
      scope_label: "Scope",
      scope_runtime: "Runtime",
      scope_shared:  "Shared",
      scope_global:  "Global",
      source_runtime: "Runtime",
      source_apc:     "APC / Shared",
      source_claude:  "Claude",
      source_codex:   "Codex",
      source_cursor:  "Cursor",
      source_vscode:  "VS Code",
      source_roo:     "Roo",
      source_gemini:  "Gemini",
      scope_runtime_desc: "Solo este proyecto · con secrets · no se commitea (~/.apx/projects/<id>/mcps.json)",
      scope_shared_desc:  "Solo este proyecto · committeable · sin secrets (.apc/mcps.json)",
      scope_global_desc:  "Todos los proyectos de esta máquina (~/.apx/mcps.json)",
      transport_stdio:    "stdio",
      transport_http:     "HTTP",
      transport_stdio_desc: "Proceso local — `command` + args",
      transport_http_desc:  "Endpoint remoto — URL + headers",
      transport_label: "Transport",
      name_label:  "Nombre",
      name_ph:     "my-mcp",
      cmd_label:   "Comando",
      cmd_ph:      "npx",
      args_label:  "Args",
      args_hint_tokens: "Una entrada por argumento. Usá el botón + para insertar variables.",
      env_label:   "Env",
      env_hint_tokens: "Pares clave/valor. Los valores aceptan ${var.NOMBRE} (botón + a la derecha).",
      env_empty:   "Sin variables de entorno.",
      url_label:   "URL",
      url_ph:      "https://example.com/v2/mcp",
      headers_label: "Headers",
      headers_hint: "Pares clave/valor — típicamente Authorization: Bearer ${var.TOKEN}.",
      headers_empty: "Sin headers.",
      enabled_label: "Habilitado",
      add_btn:     "Agregar",
      save_btn:    "Guardar",
      add_arg:     "Agregar arg",
      edit_btn:    "Editar",
      test_btn:    "Probar",
      logs_btn:    "Logs",
      testing:     "Probando…",
      test_ok:     "OK · {n} tools disponibles",
      tools_count: "{n} tools",
      logs_title:  "Logs · {name}",
      logs_empty:  "Sin logs todavía. Arrancá el MCP llamando un tool o probando.",
      logs_events: "Eventos recientes",
      logs_stderr: "stderr (últimos 4KB)",
      logs_panel_title: "Live logs",
      logs_panel_pick:  "elegí un MCP",
      logs_panel_hint:  "Click un MCP de la lista para ver lo que está pasando en vivo.",
      logs_panel_idle:  "Sin actividad. Apretá Probar para arrancarlo.",
      name_required: "Nombre requerido",
      removed:     "eliminado",
      added:       "MCP agregado.",
      updated:     "MCP actualizado.",
    },

    vars: {
      title:                "Variables",
      subtitle_project:     "Reemplazan ${var.NOMBRE} al cargar MCPs y plantillas. Las del proyecto ganan sobre las globales. Se guardan fuera del repo (~/.apx/, chmod 0600).",
      subtitle_base:        "Variables globales — disponibles para todos los proyectos. Se guardan en ~/.apx/vars.json (chmod 0600).",
      empty:                "Sin variables todavía.",
      new:                  "Variable",
      new_title:            "Nueva variable",
      edit_title:           "Editar variable",
      new_desc:             "Se referencia como ${var.NOMBRE} en cualquier campo que soporte interpolación.",
      reveal_all:           "Mostrar valores",
      reveal:               "Mostrar",
      hide:                 "Ocultar",
      filter_label:         "Mostrar:",
      filter_all:           "Todas",
      filter_project:       "Sólo proyecto",
      filter_global:        "Sólo globales",
      scope_label:          "Scope",
      scope_project:        "proyecto",
      scope_project_desc:   "Sólo este proyecto. Pisa la global con mismo nombre.",
      scope_global:         "global",
      scope_global_desc:    "Disponible en todos los proyectos.",
      name_label:           "Nombre",
      name_hint:            "Mayúsculas, dígitos y _. P. ej.: MY_API_KEY, GITHUB_TOKEN.",
      value_label:          "Valor",
      value_hint:           "Se guarda en disco con permisos 0600. Nunca se commitea.",
      value_edit_ph:        "(dejá vacío para no cambiarlo… aún no soportado, pegá el valor de nuevo)",
      add_btn:              "Agregar",
      save_btn:             "Guardar",
      edit_btn:             "Editar",
      delete_btn:           "Borrar",
      delete_confirm:       "¿Borrar {name} ({scope})?",
      removed:              "Variable eliminada.",
      added:                "Variable agregada.",
      updated:              "Variable actualizada.",
      name_required:        "Nombre requerido.",
      value_required:       "Valor requerido.",
    },

    threads: {
      title:       "Chats",
      subtitle:    "Conversaciones por agent (vacío = ningún log persistido todavía).",
      no_agents:   "No hay agents. Las conversaciones requieren un agent configurado.",
      pick:        "Elegí un agent para ver sus conversaciones.",
      empty:       "No hay conversaciones para {slug}.",
      conversation_title: "Conversación {id}",
      messages:    "mensajes",
      via:         "via",
    },

    config: {
      title:       "Config rápida",
      subtitle:    "Override del proyecto. Se escribe en {path}.",
      model:       "super_agent.model",
      model_hint:  "ej. anthropic:claude-sonnet-4.5, ollama:gemma2:9b",
      perm:        "super_agent.permission_mode",
      route:       "route_to_agent",
      route_hint:  "Slug del agent que atiende por defecto en este proyecto.",
      use_global:  "(usa global)",
      saved:       "Guardado.",
      nothing:     "Nada para guardar.",
      raw_title:   "Config (JSON crudo)",
      raw_subtitle:"Pegá el objeto entero — equivale a PUT del archivo.",
      raw_save:    "Reemplazar config",
      raw_done:    "Config sobrescrita.",
      effective:   "Effective config (read-only)",
      effective_sub: "Lo que ve realmente el daemon (global ⊕ override).",
      section_title: "Config proyecto",
      section_desc: "APC metadata y overrides separados. General APX vive en Settings > Config.",
      effective_read: "Lectura: global APX + override proyecto.",
      save_project: ".apc/project.json guardado.",
      save_override: ".apc/config.json guardado.",
      save_fields_success: "Overrides guardados.",
      save_meta_success: "Project metadata guardado.",
      no_data:     "Sin datos.",
      tab_settings: "Settings",
      tab_project:  "Project",
    },

    telegram: {
      title:        "Canal de Telegram (override)",
      subtitle:     "Si seteás un canal acá, los mensajes generados por este proyecto se mandan ahí en lugar del default.",
      use_default:  "Usar el canal default",
      bot_token:    "Bot token (override)",
      chat_id:      "Chat ID (override)",
      saved:        "Override guardado.",
      cleared:      "Override eliminado — vuelve al default.",
      override_active: "override activo",
      channel_badge: "Canal {name}",
      no_override:  "Sin override. Los mensajes de este proyecto van al canal default.",
      respond_engine: "Responder con engine",
      route_agent:  "route_to_agent",
      route_hint:   "Slug del agent que atiende (vacío = super-agent).",
      bot_hint_none: "Si vacío, hereda del default.",
    },

    memories: {
      sidebar_title:   "Memorias",
      general_group:   "General",
      general_item:    "Memoria del proyecto",
      project_title:   "Memoria del proyecto",
      project_desc:    "Hechos durables a nivel proyecto. .apc/memory.md — la leen los agentes y el super-agente.",
      project_ph:      "# Memoria del proyecto\n\nHechos estables que cualquier agente debería saber…",
      agents_title:    "Memorias de agentes",
      agents_desc:     "Memoria individual por agente. ~/.apx/projects/<id>/agents/<slug>/memory.md",
      no_agents:       "Sin agentes en este proyecto.",
      saved:           "Memoria guardada.",
      empty:           "(memoria vacía)",
      chars:           "chars · Markdown",
      save_btn:        "Guardar",
    },
  },

  base: {
    title:              "Base",
    subtitle:           "Espacio general · super-agente",
    nav_general:        "General",
    nav_activity:       "Actividad",
    nav_system:         "Sistema",
    workspaces_title:   "Workspaces",
    workspaces_desc:    "Todos los proyectos registrados en APX.",
    workspaces_new:     "Nuevo proyecto",
    workspaces_empty:   "Sin proyectos. Agregá uno con el botón de arriba.",
    sessions_title:     "Sessions",
    sessions_desc:      "Sesiones de todos los engines (apx · claude · codex), más nuevas primero.",
    sessions_desc_scoped: "Sesiones en la carpeta de este proyecto ({path}), todos los engines, más nuevas primero.",
    sessions_all:       "Todos los engines",
    sessions_empty:     "Sin sesiones.",
    sessions_error:     "No pude leer las sesiones: {msg}",
    sessions_search_ph: "Buscar sesiones…",
    sessions_deep:      "Profundo",
    sessions_deep_tip:  "También busca dentro de los transcripts (más lento)",
    sessions_clear:     "Limpiar filtros",
    sessions_refresh:   "Refrescar lista",
    sessions_no_match:  "Ninguna sesión coincide con «{q}».",
    sessions_act_cmd:   "Copiar comando apx",
    sessions_act_ask:   "Pedir a {name} que continúe",
    sessions_act_folder:"Abrir carpeta",
    sessions_act_path:  "Copiar ruta",
    sessions_cmd_copied:"Comando copiado — pegalo en tu terminal",
    sessions_path_copied:"Ruta copiada",
    sessions_copy_failed:"No se pudo copiar",
    sessions_no_folder: "Esta sesión no tiene carpeta",
    sessions_no_path:   "Esta sesión no tiene ruta",
    sessions_folder_failed:"No se pudo abrir la carpeta: {msg}",
    defaults_title:     "Agent defaults",
    defaults_desc:      "Plantillas globales del vault. Las bundled vienen con APX y siempre están; las que crees o edites quedan en ~/.apx/agents y se superponen. Importalas a un proyecto desde Agents › Importar.",
    defaults_show_removed: "Mostrar removidos",
    defaults_new:       "Nuevo",
    defaults_empty:     "Sin plantillas en el vault.",
    defaults_hide:      "Ocultar",
    defaults_restore:   "Restaurar",
    defaults_edit:      "Editar",
    defaults_remove:    "Ocultar",
    defaults_delete:    "Borrar",
    defaults_tombstone_msg: "Ocultar el default \"{slug}\"? Es bundled — quedá tombstoneado y lo recuperás con Restaurar.",
    defaults_delete_msg: "Borrar el template \"{slug}\"?",
    defaults_hidden:    "Ocultado.",
    defaults_deleted:   "Borrado.",
    defaults_restored:  "Restaurado.",
    defaults_new_title: "Nuevo template",
    defaults_new_desc:  "POST /agents/vault — se guarda en ~/.apx/agents/<slug>.md",
    defaults_edit_title: "Editar \"{slug}\"",
    defaults_bundled_desc: "Es un default bundled. Al guardar se hace copy-on-write a ~/.apx/agents/<slug>.md (queda como override).",
    defaults_user_desc:  "PATCH /agents/vault/:slug — edita el archivo en ~/.apx/agents.",
    defaults_master_label: "Agente master",
    defaults_slug_invalid: "slug inválido (debe matchear /^[a-z][a-z0-9_-]*$/)",
    defaults_created:   "Template \"{slug}\" creado.",
    defaults_saved:     "Template \"{slug}\" guardado.",
  },

  logs: {
    title:        "Logs",
    desc_global:  "Actividad del daemon (canales globales: telegram, direct…). ~/.apx/messages/<channel>/.",
    desc_project: "Actividad del proyecto. ~/.apx/projects/<id>/messages/.",
    filter_channel: "filtrar canal (ej. telegram)",
    filter_dir:   "dirección",
    all_directions: "Todas las direcciones",
    in:           "Entrada (in)",
    out:          "Salida (out)",
    filter_type:  "tipo",
    all_types:    "Todos los tipos",
    search_text:  "buscar en el texto…",
    count_of:     "de",
    no_activity:  "Sin actividad.",
    no_activity_ch: "Sin actividad en el canal \"{ch}\".",
    error:        "No pude leer los mensajes: {msg}",
    show_more:    "ver más",
    show_less:    "ver menos",
    daemon_errors: "Errores del daemon (~/.apx/logs/errors.jsonl)",
    no_errors:    "Sin errores registrados. 🎉",
  },

  telegram_contacts: {
    title:       "Contactos de Telegram",
    desc:        "Quién le escribe a los bots. El rol define qué herramientas puede usar; un invitado no tiene permisos hasta que le asignes un rol.",
    empty:       "Todavía no hay contactos — se registran solos cuando alguien escribe a un bot.",
    owner_badge: "dueño",
    assign_role: "Asignar rol",
    owner_hint:  "Es dueño de un canal — cambialo desde el canal",
    removed:     "Contacto eliminado.",
    delete_confirm: "¿Borrar el contacto {name}?",
    last_seen:   "visto:",
    tools_all:   "tools: todas",
    tools_none:  "tools: ninguna",
    tools_label: "tools:",
  },

  telegram_channels: {
    title:       "Canales",
    desc:        "Cada canal es un bot que el daemon polea. Acá podés añadir/quitar canales, cambiar el agente que contesta, el proyecto al que pertenece y su dueño.",
    new_btn:     "Nuevo canal",
    empty:       "Todavía no hay canales — agregá el primero.",
    removed:     "Canal eliminado.",
    delete_confirm: "¿Borrar el canal {name}?",
    no_owner:    "sin dueño (se reclama al primer DM)",
    owner_label: "dueño:",
  },

  telegram_channel_dialog: {
    new_title:   "Nuevo canal de Telegram",
    edit_title:  "Editar canal: {name}",
    name_label:  "name (slug interno)",
    token_label: "bot_token",
    chat_id:     "chat_id",
    project_label: "project",
    project_hint: "Slug o id del proyecto al que pinear este canal (opcional).",
    route_label: "route_to_agent",
    route_hint:  "Agente que contesta; vacío = super-agent APX.",
    owner_label: "owner_user_id",
    owner_hint:  "user_id de Telegram del dueño de este canal. Override del rol global a 'owner' acá. Si lo dejás vacío, el primer mensaje privado lo reclama.",
    owner_ph:    "889721252",
    respond_label: "Responder con engine (no echo)",
    name_required: "name requerido",
    saved:       "Canal guardado.",
  },

  telegram_send_dialog: {
    title:       "Enviar a {name}",
    default_msg: "Mensaje de prueba desde el panel de APX ✅",
  },

  telegram_roles: {
    title:       "Roles",
    desc:        "Cada rol define qué herramientas del super-agent puede usar quien lo tenga asignado. 'owner' siempre = todas; 'guest' siempre = ninguna (solo chat).",
    empty:       "No hay roles definidos.",
    tools_all:   "todas las herramientas",
    tools_none:  "ninguna herramienta",
    builtin:     "built-in",
    delete_confirm: "¿Borrar el rol \"{name}\"?",
    removed:     "Rol eliminado.",
    saved:       "Rol \"{name}\" guardado.",
    name_required: "Nombre requerido.",
    builtin_error: "\"{name}\" es un rol built-in.",
    new_title:   "Nuevo rol o reemplazar uno custom",
    name_label:  "Nombre",
    name_ph:     "editor",
    tools_label: "Tools (separadas por coma)",
    tools_hint:  "Vacío = ninguna. Ejemplos: call_agent, list_tasks, create_task.",
    tools_ph:    "call_agent, list_tasks",
    full_access: "Acceso total (todas las tools)",
    save_btn:    "Guardar rol",
    delete_btn:  "Borrar",
  },

  superagent: {
    title:          "{persona}",
    badge:          "super-agent · APX",
    desc:           "Conversación rápida con tu super-agente. Tiene acceso a tools (proyectos, tasks, mcps, agentes); para un hilo más largo y persistente, abrí Chats.",
    empty:          "Mandale un mensaje a {persona} para arrancar.",
    thinking:       "{persona} está pensando…",
    talk:           "Hablar con {persona}",
    new_chat:       "Nuevo chat",
    placeholder:    "Escribí y enter para enviar (shift+enter = nueva línea)…",
  },

  not_found: {
    title:   "404",
    message: "Roby se perdió: esta página no existe o se movió.",
    home:    "Volver al inicio",
  },

  ask_panel: {
    answers_header: "Respuestas",
    other:          "Otro",
    other_placeholder: "Escribí tu propia respuesta acá",
    text_placeholder:  "Escribí tu respuesta…",
    back:           "Atrás",
    skip:           "Omitir",
    next:           "Siguiente",
    submit:         "Enviar",
    status_waiting: "Esperando respuesta…",
    status_received: "Respuestas recibidas",
  },
  code_module: {
    title:        "Code",
    badge:        "super-agent",
    desc:         "Sesiones de código estilo OpenCode. Elegí un proyecto, abrí una sesión y pedile que lea, planifique, edite o ejecute.",
    no_projects:  "No hay proyectos registrados. Registrá uno con `apx project add` para usar Code.",
    sessions:     "Sesiones",
    new_session:  "Nueva sesión",
    untitled:     "Nueva sesión",
    no_sessions:  "Todavía no hay sesiones — creá una para empezar a codear.",
    pick_project: "Elegí un proyecto para ver sus sesiones.",
    rename:       "Renombrar",
    delete:       "Eliminar",
    delete_confirm: "¿Eliminar esta sesión? Se borra la transcripción; tus archivos quedan intactos.",
    empty_chat:   "Mandá una instrucción de código para arrancar.",
    placeholder:  "Pedí un cambio… (enter envía, shift+enter = nueva línea)",
    mode_build:   "Build",
    mode_plan:    "Plan",
    mode_build_hint: "Build — edita archivos y ejecuta comandos",
    mode_plan_hint:  "Plan — solo lectura, propone cambios sin tocar archivos",
    tab_context:  "Contexto",
    tab_changes:  "Cambios",
    tab_artifacts: "Artifacts",
    artifacts_none: "Todavía no hay artifacts. Pedile al agente que cree un script en `artifacts/<nombre>`.",
    artifacts_count: "{n} artifact(s)",
    artifacts_copy_path: "Copiar path",
    artifacts_run: "Run",
    artifacts_run_hint: "Para ejecutarlo desde la terminal:",
    artifacts_delete: "Eliminar",
    artifacts_delete_confirm: "¿Eliminar este artifact? El archivo se borra del disco.",
    ctx_model:    "Modelo",
    ctx_tokens:   "Tokens",
    ctx_input:    "Entrada",
    ctx_output:   "Salida",
    ctx_messages: "Mensajes",
    ctx_breakdown: "Desglose de contexto",
    ctx_none:     "Sin uso todavía — mandá un turno para ver tokens.",
    seg_system:   "Sistema",
    seg_user:     "Usuario",
    seg_assistant: "Asistente",
    seg_tool:     "Tools",
    seg_other:    "Otro",
    changes_none: "Todavía no hay cambios en esta sesión.",
    changes_no_git: "Los cambios necesitan un repo git. Este proyecto no lo es.",
    changes_files: "{n} archivo(s) cambiados",
    stopped:      "[detenido]",
    close:               "Cerrar",
    reload:              "Recargar",
    discard_changes:     "Descartar cambios",
    save_shortcut_hint:  "Guardar (Cmd/Ctrl+S)",
    artifacts_rename:    "Renombrar",
    artifacts_view:      "Ver contenido",
    artifacts_edit:      "Editar contenido",
    artifacts_preview:       "Previsualizar",
    artifacts_preview_hint:  "Abrir una previsualización en vivo en una pestaña local",
    artifacts_share:         "Compartir",
    artifacts_share_hint:    "Crear una URL pública por túnel para compartir esta preview",
    artifacts_stop_preview:  "Detener preview",
    artifacts_preview_local: "Preview local",
    artifacts_preview_public:"URL pública",
    artifacts_copy_url:      "Copiar URL",
    artifacts_preview_started: "Preview activa en {url}",
    tree_collapse_all:   "Colapsar todo",
    terminal_clear:      "Limpiar",
    terminal_close:      "Cerrar terminal",
  },

  desktop_screen: {
    status_title:        "Estado",
    autostart_title:     "Arranque automático",
    shortcut_title:      "Atajo de teclado",
    appearance_title:    "Apariencia",
    activation_title:    "Activación + transcripción",
    last_conv_title:     "Última conversación",
    open_config:         "Configuración",
  },

  voice_screen: {
    providers_title:     "Proveedores de voz (TTS)",
    test_title:          "Probar voz",
    stt_title:           "Transcripción (STT)",
    configure_provider:  "Configurar {name}",
  },

  deck_screen: {
    widgets_title:       "Widgets",
    context_title:       "Contexto APX",
    reload_manifest:     "Recargar manifest",
    widget_native:       "Widget nativo APX",
    widget_external:     "Widget externo",
    preview_badge:       "Vista previa",
    preview_title:       "Deck — Próximamente",
    preview_body:        "El módulo Deck todavía está en desarrollo y no fue lanzado aún. Lo volveremos a activar cuando Deck salga en una versión estable. Por ahora todo acá es de solo lectura y no se guardará ningún cambio.",
  },

  memory_panel: {
    embeddings_title:    "Embeddings (RAG)",
    embeddings_desc:     "Modelo que vectoriza el historial de todos los canales para la memoria relevante. Igual que TTS/STT: elegí un proveedor y un modelo. 'Automático' prueba local primero y cae a offline si no hay nada disponible.",
    provider_label:      "Proveedor",
    provider_hint:       "Ollama es local y gratis. Gemini/OpenAI usan la API key de su sección en Modelos (o la de abajo).",
    mode_label:          "Modo de selección",
    mode_hint:           "Cadena cae al siguiente si uno falla; Único usa exactamente el proveedor elegido.",
    available:           "disponible",
    unavailable:         "no disp.",
    test_btn:            "Probar embedding",
    reindex_btn:         "Reindexar memoria",
    test_ok:             "Embedding OK con {embedder}",
    test_failed:         "Test falló: {msg}",
    reindexed:           "Reindexado: {indexed} chunks (limpiados {cleared}).",
    reindex_failed:      "Reindex falló: {msg}",
    save_failed:         "No se pudo guardar: {msg}",
    provider_auto:       "Automático (cadena: Ollama → Gemini → OpenAI → offline)",
    provider_ollama:     "Ollama — local, sin API key (nomic-embed-text)",
    provider_gemini:     "Gemini — free tier con key (text-embedding-004)",
    provider_openai:     "OpenAI — text-embedding-3-small (cloud)",
    provider_tf:         "Offline (term-frequency, sin modelo — degradado)",
    mode_chain:          "Cadena (fallback automático)",
    mode_single:         "Único (usa solo el elegido)",
    ollama_title:        "Ollama (local)",
    ollama_desc:         "Sin API key. Corre nomic-embed-text en tu Ollama local o cloud.",
    model_label:         "Modelo",
    base_url_label:      "Base URL",
    ollama_base_url_hint:"Vacío usa engines.ollama.base_url (default http://localhost:11434).",
    openai_title:        "OpenAI",
    openai_desc:         "text-embedding-3-small (1536 dims) u otro modelo compatible.",
    api_key_label:       "API key",
    openai_key_hint:     "Vacío reusa engines.openai.api_key. Dejalo en blanco para mantener la guardada.",
    gemini_title:        "Gemini",
    gemini_desc:         "text-embedding-004 (768 dims). Free tier con API key de Google.",
    gemini_key_hint:     "Vacío reusa engines.gemini.api_key.",
    compaction_title:    "Compactación de historial",
    compaction_desc:     "Cuando un chat supera el umbral de turnos, los más viejos se resumen con un LLM liviano (local) y se guardan como [RESUMEN COMPACTADO], manteniendo el contexto acotado. Corre fuera del hot-path: el turno actual usa el resumen que ya exista.",
    threshold_label:     "Umbral de compactación",
    threshold_hint:      "Compactar una vez que el chat supera estos turnos (por defecto 60).",
    keep_recent_label:   "Turnos recientes a preservar",
    keep_recent_hint:    "Turnos verbatim que NUNCA se compactan (por defecto 40). Debe ser menor al umbral.",
    compact_model_label: "Modelo de compactación",
    compact_model_hint:  "LLM liviano para resumir. Ideal uno local (Ollama) para no gastar. Formato proveedor:modelo.",
    compact_fallback_label: "Modelo de fallback",
    compact_fallback_hint:  "Se usa si el de compactación falla. Vacío cae al modelo del super-agente.",
    compact_fallback_ph: "(vacío → modelo del super-agente)",
  },

  router_panel: {
    title:               "Router de modelos",
    description:         "Un único router general (sin casos por tarea). Elegí un proveedor y un modelo; si el activo falla, prueba la cadena de fallback en orden.",
    badge_default:       "default",
    no_providers:        "Agregá un proveedor abajo para poder elegir modelos.",
    active_model_label:  "Modelo activo (default)",
    active_model_hint:   "Proveedor + modelo. Se guarda como proveedor:modelo.",
    fallback_title:      "Cadena de fallback",
    fallback_desc:       "Si el modelo activo falla, prueba estos en orden. Click en uno para editarlo.",
    fallback_empty:      "Sin fallback configurado.",
    add_to_chain:        "Agregar a la cadena",
    done:                "listo",
    save:                "Guardar router",
    saved:               "Guardado",
    saved_toast:         "Router guardado.",
    provider_ph:         "— proveedor —",
    provider_not_found:  "⚠ {name} (no encontrado)",
    provider_not_configured: "El proveedor \"{name}\" no está configurado.",
  },

  routing_panel: {
    title:            "Ruteo por contenido",
    description:      "Elegí un modelo distinto por mensaje según su contenido (imagen, tamaño, canal, keywords). Aparte de la cadena de fallback de arriba.",
    signal_on:        "Ruteo por contenido: ON ({n} reglas)",
    signal_on_empty:  "Ruteo por contenido: ON (todavía sin reglas)",
    signal_off:       "Ruteo por contenido: OFF",
    how_it_works:     "¿Cómo funciona?",
    enable_label:     "Activar ruteo por contenido",
    rules_title:      "Reglas de ruteo",
    rules_desc:       "Se evalúan de arriba hacia abajo; gana la primera regla que cumpla todas sus condiciones.",
    rules_empty:      "Todavía sin reglas. Agregá algunas en el editor.",
    edit_rules:       "Editar reglas (JSON)",
    hide_editor:      "Ocultar editor",
    editor_label:     "Reglas (array JSON)",
    json_hint:        "Array de { model, when }. Claves de when: has_image, min_prompt_chars, max_prompt_chars, min_context_chars, channels[], keywords[]. when vacío = matchea todos los mensajes.",
    json_error:       "JSON inválido: {msg}",
    json_not_array:   "Las reglas tienen que ser un array JSON.",
    insert_example:   "Insertar un ejemplo",
    when_any:         "cualquier mensaje",
    when_image:       "tiene imagen",
    when_no_image:    "sin imagen",
    when_min_prompt:  "prompt ≥ {n} chars",
    when_max_prompt:  "prompt ≤ {n} chars",
    when_min_context: "contexto ≥ {n} chars",
    when_channels:    "canales: {list}",
    when_keywords:    "keywords: {list}",
    helper:           "El ruteo elige un modelo por mensaje (imagen, tamaño, canal, keywords). Se compone con el failover: un modelo ruteado que esté caído cae por la cadena. Un override de modelo explícito por request siempre gana.",
    save:             "Guardar ruteo",
    saved:            "Guardado",
    saved_toast:      "Ruteo por contenido guardado.",
    confirm_title:    "¿Aplicar los cambios de ruteo?",
    confirm_body:     "Esto cambia qué modelo atiende cada mensaje. El failover sigue aplicando si un modelo ruteado está caído.",
    confirm_on:       "El ruteo por contenido va a quedar ON con {n} reglas.",
    confirm_off:      "El ruteo por contenido va a quedar OFF (cada mensaje usa el router default).",
    confirm_apply:    "Aplicar",
    cancel:           "Cancelar",
  },

  engines_panel: {
    title:               "Proveedores",
    new_btn:             "Nuevo proveedor",
    description:         "Proveedores LLM (API). Cada provider usa un engine/adapter (openai, ollama, …) con su key y URL.",
    empty:               "Sin providers. Agregá uno con el botón de arriba.",
    add_card:            "Agregar provider",
    saved:               "Provider guardado.",
    saved_json:          "Provider guardado (JSON).",
    deleted:             "Provider borrado.",
    delete_confirm:      "¿Borrar provider {name}?",
  },

  providers_modal: {
    new_title:           "Nuevo proveedor",
    edit_title:          "Editar {name}",
    description:         "Proveedor LLM. El motor (engine) define qué adapter usa (openai, ollama, …).",
    list_models_hint:    "Listar los modelos reales del proveedor",
    toggle_active:       "Activo · click para desactivar",
    toggle_inactive:     "Inactivo · click para activar",
    delete:              "Borrar",
    custom:              "Custom",
    json_mode:           "JSON",
    form_mode:           "Volver al formulario",
    json_label:          "Config del provider (JSON)",
    json_hint:           "Se guarda como engines.{slug} en config.json",
    json_help:           "Debe ser un objeto JSON válido con al menos engine. El slug se toma del formulario.",
    name_label:          "Nombre",
    name_ph:             "Mi provider",
    engine_label:        "Motor (engine)",
    base_url_label:      "URL base (base_url)",
    base_url_hint:       "Se completa sola al elegir un proveedor.",
    base_url_ph:         "https://api.openai.com/v1",
    api_key_label:       "API key",
    api_key_hint_existing: "Dejá en blanco para mantener la actual.",
    api_key_hint_env:    "Se guarda como secreto. Env sugerida: {env}",
    api_key_hint:        "Se guarda como secreto.",
    api_key_set:         "…{suffix} (ya seteada)",
    model_label:         "Modelo por defecto",
    load_models:         "Cargar modelos",
    max_tokens_label:    "Máx. tokens (max_tokens)",
    temperature_label:   "Temperatura: {value}",
    pricing_summary:     "Análisis de tokens / pricing (opcional)",
    context_limit_label: "Límite de contexto (tokens)",
    price_input:         "$ entrada / 1M",
    price_output:        "$ salida / 1M",
    price_cache_read:    "$ cache read / 1M",
    price_cache_write:   "$ cache write / 1M",
    model_limits_label:  "Límites de contexto por modelo (JSON)",
    active_label:        "Activo (los agentes pueden usarlo)",
    err_slug_required:   "Slug requerido.",
    err_slug_required_form: "Slug requerido (en el formulario).",
    err_slug_exists:     "Ya existe un provider \"{slug}\".",
    err_model_limits_json: "Límites de contexto por modelo: JSON inválido.",
    err_json_invalid:    "JSON inválido: revisá la sintaxis.",
    err_json_object:     "El JSON debe ser un objeto con la config del provider.",
    err_engine_missing:  "Falta \"engine\" (ej. \"anthropic\", \"ollama\").",
    err_save:            "Error al guardar.",
    err_no_models:       "Sin modelos. ¿Key/URL correctas?",
    err_list_models:     "No se pudo listar modelos.",
  },

  providers_card: {
    active:              "Activo",
    off:                 "Off",
    model:               "Modelo",
    base_url:            "Base URL",
    api_key:             "API key",
    key_set:             "✓ seteada",
    temp:                "Temp",
    price_io:            "$ in/out (1M)",
  },

  chat_ui: {
    copy:                "Copiar",
    stop:                "Detener",
    send:                "Enviar",
    pick_model:          "Elegir modelo (o Auto)",
    insert_variable:     "Insertar variable",
  },

  sidebar_ui: {
    toggle:              "Mostrar/ocultar sidebar",
  },

  models_ui: {
    invalid_hint:        "Modelo/proveedor no disponible",
  },

  global_config: {
    title:               "Config APX",
  },

  agent_detail_extra: {
    skills_title:        "Skills & tools",
  },

  voice_ui: {
    api_key_label:        "API key",
    api_key_set:          "…{suffix} (ya seteada)",
    api_key_keep_hint:    "Dejá en blanco para mantener la actual.",
    api_key_secret_hint:  "Se guarda como secreto. Env: {env}",
    api_key_reuse_hint:   "Si lo dejás vacío, reusa {engine}. Env: {env}",
    err_save:             "Error al guardar.",
    model_label:          "Modelo",
    voice_label:          "Voz",
    format_label:         "Formato",
    output_format_label:  "Formato de salida",
    voice_id_label:       "Voice ID",
    voice_id_hint:        "Voice id de ElevenLabs (vacío = default).",
    gemini_model_hint:    "El TTS de Gemini todavía está en preview.",
    base_url_label:       "Base URL (opcional)",
    base_url_hint:        "Endpoint compatible con OpenAI. Vacío = OpenAI. Apuntalo a un servidor local (ej. un daemon QVox / Qwen3-TTS) para usar ese en su lugar.",
    openai_model_hint:    "tts-1 / tts-1-hd para OpenAI. Dejalo vacío para que un servidor custom elija.",
    openai_voice_hint:    "Preset de OpenAI (alloy…) o preset de tu servidor custom (ej. custom). Vacío = default del servidor.",
    openai_style_hint:    "Voz base / instruct, usada por endpoints custom (la persona que se mantiene en todo el audio). El tts-1 de OpenAI la ignora.",
    style_label:          "Estilo (cómo debería hablar)",
    style_hint:           "Instrucción en lenguaje natural. Vacío = sin estilo. Ej.: 'hablá en un tono alegre y pausado'.",
    style_ph:             "hablá en un tono alegre y enérgico",
    temperature_label:    "Temperatura (opcional)",
    temperature_hint:     "Temperatura de sampleo para endpoints custom. Vacío = default del servidor.",
    emotions_short:       "Emociones",
    emotions_label:       "Tags de emoción inline",
    emotions_hint:        "Cuando hable este motor, deja que el agente meta tags tipo [happy]/[whisper] en las respuestas de voz para darles color. Activalo solo si este motor entiende los tags (ej. un endpoint QVox/Qwen3-TTS) — si no, se quitan antes de sintetizar.",
    emotions_tags_label:  "Tags permitidos",
    emotions_tags_hint:   "Separados por coma. Vacío = el set por defecto.",
    piper_bin_label:      "Binario (bin)",
    piper_bin_hint:       "Ruta o nombre del CLI de piper (PATH).",
    piper_model_label:    "Modelo (.onnx)",
    piper_model_hint:     "Ruta absoluta al modelo de voz de piper.",
    piper_speaker_label:  "Speaker (opcional)",
    piper_speaker_hint:   "Speaker id para modelos multi-voz.",
    mock_desc:            "El engine mock genera un WAV de prueba en silencio. No tiene parámetros: sirve como fallback garantizado cuando no hay ningún otro engine configurado.",
    selection_mode:       "Modo de selección",
    mode_chain_desc:      "Cadena con fallback: usa el primer engine disponible siguiendo el orden de abajo.",
    mode_single_desc:     "Solo engine default: siempre usa el elegido; el resto queda configurado para otros usos.",
    mode_chain_btn:       "Cadena (router)",
    mode_single_btn:      "Solo engine default",
    move_up:              "Subir",
    move_down:            "Bajar",
    badge_local:          "local",
    badge_available:      "disponible",
    badge_unavailable:    "configurado, no disponible",
    badge_not_configured: "sin configurar",
    badge_default:        "default",
    badge_custom:         "custom",
    set_as_default:       "Usar como default",
    configure:            "Configurar",
    remove:               "Quitar",
    remove_confirm:       "¿Quitar este proveedor custom?",
    add_provider:         "Agregar proveedor",
    new_provider:         "Nuevo proveedor",
    custom_note:          "Endpoint custom compatible con OpenAI.",
    custom_desc:          "Cualquier endpoint de voz compatible con OpenAI (ej. un servidor local QVox / Qwen3-TTS).",
    label_label:          "Nombre",
    label_hint:           "Nombre para mostrar de este proveedor.",
    base_url_req_label:   "Base URL",
    base_url_req_hint:    "Requerido. El endpoint compatible con OpenAI, ej. http://127.0.0.1:5111/v1",
    api_key_optional_hint:"Opcional — solo si tu servidor pide key.",
    advanced:             "Avanzado",
    custom_model_hint:    "Opcional. La mayoría de los servidores locales lo ignoran (ej. QVox).",
    custom_voice_hint:    "Opcional. Un preset que entienda tu servidor (ej. custom). Vacío = default del servidor.",
    custom_optional_ph:   "(opcional)",
    stt_engine_label:     "Engine de transcripción",
    stt_engine_hint:      "Local usa faster-whisper (requiere python3 + faster-whisper). OpenAI usa la key de engines.openai.",
    stt_model_label:      "Modelo local (whisper)",
    stt_model_hint:       "Más grande = más preciso y más lento.",
    stt_language_label:   "Idioma",
    stt_language_hint:    "Para español, elegir \"Español\" mejora la precisión.",
    stt_provider_auto:    "Automático (local, después remoto)",
    stt_provider_local:   "Local — faster-whisper (offline)",
    stt_provider_openai:  "OpenAI — Whisper-1 (cloud)",
    stt_provider_custom:  "Custom — server OpenAI-compatible",
    stt_openai_model_label: "Modelo OpenAI",
    stt_openai_model_hint:  "Por defecto whisper-1.",
    stt_custom_baseurl_label: "URL base (OpenAI-compatible)",
    stt_custom_baseurl_hint:  "Ej: http://localhost:8000/v1 (mlx-audio en Metal) o http://192.168.1.50:9000/v1 (Radeon/NVIDIA en la red).",
    stt_custom_model_label:   "Modelo",
    stt_custom_model_hint:    "Ej: mlx-community/whisper-large-v3-turbo o large-v3.",
    stt_custom_key_hint:      "Opcional — la mayoría de los servers locales no requieren key.",
    stt_hw_label:             "Hardware detectado",
    stt_hw_recommended:       "Recomendado",
    stt_hw_limited:           "aceleración GPU limitada, se usa CPU",
    stt_backend_label:        "Aceleración / Motor",
    stt_backend_hint:         "Auto elige según tu hardware. Metal corre en la GPU (mlx); CPU usa faster-whisper.",
    stt_backend_auto:         "Automático (recomendado)",
    stt_model_needs_download: "Falta descargar (~{size}). Hay que bajar el modelo para usar este motor.",
    lang_auto:            "Detección automática",
    lang_es:              "Español",
    lang_en:              "Inglés",
    lang_pt:              "Portugués",
    lang_fr:              "Francés",
    lang_it:              "Italiano",
    lang_de:              "Alemán",
    test_default_text:    "Hola, soy APX. Esto es una prueba de voz.",
    test_default_engine:  "Default ({name})",
    test_default_chain:   "Default (cadena)",
    test_unavailable_suffix: " · no disponible",
    test_empty_error:     "Escribí algo para decir.",
    test_synth_error:     "No se pudo sintetizar.",
    test_engine_label:    "Engine",
    test_engine_hint:     "Override del default para probar.",
    test_style_label:     "Estilo (solo Gemini)",
    test_style_hint:      "Cómo debería hablar. Vacío = sin estilo.",
    test_text_label:      "Texto a decir",
    test_text_ph:         "Escribí lo que querés que diga…",
    say_this:             "Decir esto",
    stop:                 "Detener",
    replay:               "Repetir",
    engine_result:        "Engine",
    providers_desc:       "Engines de síntesis, en orden de fallback. El estado lo reporta el daemon en vivo. Agregá tus propios endpoints compatibles con OpenAI.",
    providers_load_error: "No pude cargar los proveedores: {msg}",
    test_desc:            "Elegí con qué engine sintetizar y, si aplica, cómo debería hablar.",
    stt_desc:             "Engine de speech-to-text que usan el deck, Telegram y la CLI al escuchar.",
    toast_default_engine: "Engine default: {id}.",
    toast_mode_chain:     "Modo: cadena con fallback.",
    toast_mode_single:    "Modo: solo engine default.",
    toast_config_saved:   "Configuración de voz guardada.",
    toast_provider_removed: "Proveedor eliminado.",
    err_label_required:   "Falta el nombre.",
    err_base_url_required:"Falta la base URL.",
    toast_transcription_updated: "Transcripción actualizada.",
  },

  telegram_ui: {
    channel_dialog_desc:   "POST /telegram/channels (upsert) — PATCH /telegram/channels/:name (parcial).",
    bot_token_hint:        "Token de BotFather. Se guarda en ~/.apx/config.json.",
    bot_token_hint_short:  "Token de BotFather.",
    secret_set_replace:    "(seteado — escribí para reemplazar)",
    secret_already_set:    "(ya seteado)",
    empty_keep:            "— vacío = mantener",
    message_sent:          "Mensaje enviado.",
    message_label:         "Texto",
    send_chat_id:          "chat_id: {id}",
    default_apx:           "APX por defecto",
    yes:                   "sí",
    no:                    "no",
    user_id_fallback:      "user_id {id}",
    role_assigned:         "{name} → {role}",
  },

  agents_form: {
    emoji:           "Emoji",
    area:            "Área",
    role:            "Rol",
    no_role:         "— sin rol —",
    autonomy:        "Autonomía",
    autonomy_hint:   "Cuánto puede hacer el agente sin pedir confirmación.",
    auto_total:      "Total",
    auto_automatico: "Auto",
    auto_permiso:    "Permiso",
  },

  structure: {
    title:            "Estructura",
    subtitle:         "Áreas y roles de la empresa. Las áreas agrupan agentes; los roles definen su función.",
    info:             "Las áreas son agrupaciones opcionales. Los roles definen la función de un agente y pueden pertenecer a un área.",
    empty:            "Todavía no hay áreas ni roles. Creá el primero arriba.",
    new_area:         "Nueva área",
    new_role:         "Nuevo rol",
    edit_area:        "Editar área",
    edit_role:        "Editar rol",
    create_area:      "Crear área",
    create_role:      "Crear rol",
    name:             "Nombre",
    slug:             "Slug",
    goal:             "Objetivo",
    goal_hint:        "Para qué existe esta área (opcional).",
    area:             "Área",
    description:      "Descripción",
    no_area:          "— sin área —",
    roles:            "Roles",
    add_role:         "rol",
    no_roles:         "sin roles",
    general_roles:    "Roles generales",
    delete_area:      "Borrar área",
    delete_role:      "Borrar rol",
    delete_area_desc: "¿Borrar el área \"{name}\"? Sus roles quedan sin área, no se eliminan.",
    delete_role_desc: "¿Borrar el rol \"{name}\"?",
  },

  files: {
    docs_label:    "Docs",
    files_label:   "Archivos",
    new_doc:       "Nuevo documento",
    new_doc_hint:  "Podés usar carpetas: cases/onboarding/spec.md",
    empty:         "No hay archivos.",
    docs_empty:    "Todavía no hay documentación. Creá el primer documento.",
    truncated:     "Listado recortado (demasiados archivos).",
    select_prompt: "Elegí un archivo para verlo.",
    save:          "Guardar",
    saved:         "Guardado.",
    deleted:       "Eliminado.",
    created:       "Documento creado.",
    edit:          "Editar",
    preview:       "Preview",
    discard:       "Descartar",
    no_preview:    "No hay preview para este archivo.",
    too_large:     "Archivo demasiado grande para mostrar.",
    path_label:    "Ruta del archivo",
    path_example:  "ej. cases/onboarding/spec.md",
    create:        "Crear",
  },

  tasks: {
    state_open:      "abiertas",
    state_done:      "hechas",
    state_dropped:   "descartadas",
    status_pending:   "pendiente",
    status_running:   "corriendo",
    status_in_review: "en revisión",
    status_blocked:   "bloqueada",
    done_label:      "hecha",
    dropped_label:   "descartada",
    detail_title:    "Detalle de task",
    field_title:     "Título",
    field_prompt:    "Prompt",
    field_status:    "Estado",
    field_agent:     "Agente",
    field_creator:   "Creada por",
    field_source:    "Origen",
    field_created:   "Creada",
    field_updated:   "Actualizada",
    field_done:      "Completada",
    prompt_ph:       "Descripción / prompt de la task…",
    toggle_prompt:   "Prompt",
    view_thread:     "Ver conversación",
    mark_done:       "Completar",
  },

  agents_ui: {
    model_router_default:    "modelo: default del router",
    slug_kebab_hint:         "kebab-case, ej. reviewer, my-agent, content-writer",
    comma_separated:         "separadas por coma",
    body_hint:               "markdown — extiende el system prompt del agente",
    source_user:             "user",
    source_override:         "override",
    source_bundled:          "bundled",
    tab_explorer:            "Explorador",
    type_none:               "— sin tipo —",
    type_orchestrator:       "Orquestador",
    type_orchestrator_desc:  "Coordina el equipo y delega.",
    type_specialist:         "Especialista",
    type_specialist_desc:    "Experto en el dominio; corre tareas.",
    type_assistant:          "Asistente",
    type_assistant_desc:     "Ayudante conversacional.",
    type_worker:             "Worker",
    type_worker_desc:        "Corre tareas autónomas.",
    type_monitor:            "Monitor",
    type_monitor_desc:       "Vigila el estado y reporta.",
    stat_threads:            "Threads",
    stat_records:            "Records",
    stat_tasks:              "Tasks",
    stat_heartbeats:         "Heartbeats",
    uncategorized:           "Sin categoría",
    config_def_desc:         "definición (frontmatter + system prompt).",
    memory_durable_desc:     "hechos durables que el agente recuerda.",
    running:                 "running",
    paused:                  "pausada",
    last_error:              "última: error",
    field_tick:              "Tick",
    field_next_tick:         "Próximo tick",
    field_last_tick:         "Último tick",
    field_last_run:          "Última corrida",
    tools_label:             "Tools",
    kind_agent:              "agente",
    kind_memory:             "memoria",
    kind_thread:             "thread",
    kind_task:               "task",
    kind_routine:            "rutina",
    kind_hierarchy:          "jerarquía",
    nodes_drag_hint:         "{n} nodos · arrastrá para reordenar",
    kind_exec_agent:         "Agente del proyecto",
    kind_exec_agent_desc:    "Corre un agente del proyecto con un prompt. Vos elegís cuál.",
    kind_super_agent:        "Super-agente",
    kind_super_agent_desc:   "Llama al super-agente APX con un prompt.",
    kind_telegram:           "Telegram",
    kind_telegram_desc:      "Manda un mensaje fijo a un canal de Telegram. Sin modelo ni agente.",
    kind_shell:              "Shell",
    kind_shell_desc:         "Corre un comando shell. Sin prompt ni pre/post — el comando es la acción.",
    kind_heartbeat:          "Heartbeat",
    kind_heartbeat_desc:     "No hace nada salvo escribir una línea en los logs cada vez que corre. Sirve para confirmar que el scheduler está vivo. Si no sabés si lo necesitás, no lo uses.",
    unit_seconds:            "segundos",
    unit_minutes:            "minutos",
    unit_hours:              "horas",
    unit_days:               "días",
    every_n_unit:            "cada {n} {unit}",
    every_v:                 "cada {v}",
    preset_every_10m:        "cada 10 min",
    preset_hourly:           "cada hora",
    preset_daily_9am:        "diario 9am",
    preset_weekdays_9am:     "días hábiles 9am",
    preset_manual:           "Manual",
    var_pre_output_prompt:   "Salida de texto de los pre-commands. Se reemplaza dentro del prompt/texto antes de enviarlo. Útil para inyectar datos frescos (clima, una API) en la instrucción.",
    var_llm_output:          "Respuesta final del agente o super-agente. Disponible en los post-commands como variable de entorno. Ej: reenviarla por Telegram.",
    var_status:              "Resultado de la acción: ok o error. Disponible en los post-commands para decidir qué hacer después.",
    var_skipped:             "Vale 1 si la acción se salteó (por skip_prompt_on), 0 si corrió. Disponible en los post-commands.",
    var_pre_output:          "Salida completa de los pre-commands, como variable de entorno en los post-commands (hasta 32k).",
    var_pre_output_file:     "Ruta a un archivo temporal con la salida de los pre-commands. Para salidas grandes que no convienen como variable.",
    var_pre_exit:            "Código de salida del último pre-command (0 = ok). Disponible en los post-commands.",
    var_routine:             "Nombre de esta rutina. Disponible como variable de entorno en los comandos.",
    summary_runs_agent:      "Corre el agente \"{agent}\"",
    summary_runs_agent_none: "Corre un agente (todavía no elegiste cuál)",
    summary_super_agent:     "Llama al super-agente",
    summary_telegram:        "Manda Telegram a \"{channel}\"",
    summary_runs_cmd:        "Corre: {cmd}",
    summary_shell:           "Corre un comando shell",
    summary_heartbeat:       "Deja un heartbeat en los logs",
    action_agent_answers:        "El agente \"{agent}\" responde el prompt",
    action_agent_pick_answers:   "El agente (elegí uno) responde el prompt",
    action_super_answers:        "El super-agente responde el prompt",
    action_telegram_channel:     "Manda Telegram al canal \"{channel}\"",
    action_runs_shell:           "Corre el comando shell",
    step_pre:                "Pre",
    step_post:               "Post",
    last_label:              "última:",
    tg_chat_id_ph:           "(usa el del canal)",
    tg_text_ph:              "mensaje a enviar",
    hb_message_ph:           "sigo vivo",
    arg_placeholder:         "--flag o valor",
    remove_arg:              "quitar arg",
    super_agent_label:       "{persona} (super-agente)",
    super_agent_badge:       "super-agente",
  },

  modules_ui: {
    desktop_pos_left:        "Izquierda",
    desktop_pos_center:      "Centro",
    desktop_pos_right:       "Derecha",
    desktop_theme_system:    "Sistema",
    desktop_theme_light:     "Claro",
    desktop_theme_dark:      "Oscuro",
    desktop_status_desc:     "La ventana se abre desde la terminal o por arranque automático.",
    desktop_running:         "Corriendo",
    desktop_stopped:         "Detenida",
    desktop_refresh:         "refrescar",
    desktop_start:           "Iniciar",
    desktop_stop:            "Detener",
    desktop_restart:         "Reiniciar",
    desktop_restart_hint:    "Recarga la ventana abierta para aplicar ya los cambios de config (tema, posición).",
    desktop_restart_done:    "Reiniciando la ventana — aplicando la última config.",
    desktop_restart_none:    "No hay ninguna ventana de desktop conectada.",
    desktop_start_done:      "Ventana de desktop iniciada.",
    desktop_start_already:   "La ventana de desktop ya estaba corriendo.",
    desktop_stop_done:       "Ventana de desktop detenida.",
    desktop_stop_none:       "No había ninguna ventana de desktop corriendo.",
    desktop_from_terminal:   "Desde la terminal:",
    desktop_autostart_desc:  "Abre la ventana al iniciar sesión. Equivale a `apx desktop install` (no requiere sudo).",
    desktop_platform:        "plataforma: {platform}",
    desktop_shortcut_desc:   "Atajo global que muestra/oculta la ventana y empieza a escuchar.",
    desktop_accelerator:     "Acelerador",
    desktop_accelerator_hint:"Hacé clic en el campo y apretá tu combinación de teclas. Reiniciá la ventana para aplicar.",
    desktop_shortcut_record:    "Hacé clic para definir un atajo",
    desktop_shortcut_recording: "Apretá tu combinación…",
    desktop_shortcut_change:    "clic para cambiar",
    desktop_shortcut_esc:       "Esc para cancelar",
    desktop_shortcut_saved:  "Atajo guardado. Reiniciá la ventana (apx desktop stop && start) para aplicarlo.",
    desktop_autostart_on:    "Arranque automático habilitado para el próximo inicio de sesión.",
    desktop_autostart_off:   "Arranque automático deshabilitado.",
    desktop_appearance_desc: "Tema de la ventana y posición en la pantalla.",
    desktop_theme:           "Tema",
    desktop_restart_apply:   "Reiniciá la ventana para aplicar.",
    desktop_theme_set:       "Tema: {value}.",
    desktop_position:        "Posición",
    desktop_position_hint:   "\"izquierda\" / \"centro\" / \"derecha\" del borde superior.",
    desktop_position_set:    "Posición: {value}.",
    desktop_activation_desc: "El plugin del daemon procesa los mensajes. El STT se configura en Voces.",
    desktop_enabled_toast:   "Escritorio habilitado.",
    desktop_disabled_toast:  "Escritorio deshabilitado.",
    desktop_plugin_on:       "Plugin habilitado (responde mensajes)",
    desktop_plugin_off:      "Plugin deshabilitado",
    desktop_stt_engine:      "Motor de speech-to-text:",
    desktop_stt_engine_suffix:"(whisper local, idioma, modelo).",
    desktop_last_conv_desc:  "El último intercambio con el agente desde la ventana flotante.",
    desktop_no_messages:     "Todavía no hay mensajes. Mandá algo a la ventana de escritorio para que aparezca acá.",
    desktop_you:             "Vos",
    desktop_roby:            "Roby",
    desktop_empty_msg:       "(vacío)",
    deck_widget_enabled:     "Widget {id} habilitado.",
    deck_widget_disabled:    "Widget {id} deshabilitado.",
    deck_save_error:         "Error al guardar",
    deck_loading_manifest:   "Cargando manifest…",
    deck_manifest_error:     "Error al cargar el manifest.",
    deck_widgets_summary:    "{count} widgets · {enabled} externos habilitados",
    deck_loading_manifest_full:"Cargando el manifest del Deck…",
    deck_manifest_load_failed:"No se pudo cargar el manifest del Deck.",
    deck_retry:              "Reintentar",
    deck_no_widgets:         "No hay widgets en el manifest.",
    deck_context_desc:       "Información que el Deck ve desde el daemon.",
    deck_active_project:     "Proyecto activo:",
    deck_none:               "ninguno",
    deck_registered_projects:"Proyectos registrados:",
    deck_active_plugins:     "Plugins activos:",
    deck_daemon_active:      "activo · {uptime}",
    deck_daemon_started:     "iniciado",
    deck_safety_no_shell:    "sin shell directo",
    deck_safety_no_arbitrary:"comandos arbitrarios bloqueados",
    deck_safety_confirm:     "las acciones peligrosas requieren confirmación",
    code_copied:             "Copiado.",
    code_saved:              "Guardado.",
    code_file_empty:         "(vacío)",
    code_file_error:         "Error: {msg}",
    code_stream_error:       "error",
    code_super_agent:        "super-agent",
    code_super_agent_desc:   "Agente principal con todas las tools",
    code_chat_tab:           "Chat",
    code_panel_sessions:     "Lista de sesiones",
    code_panel_tree:         "Árbol de archivos",
    code_panel_terminal:     "Terminal",
    code_panel_context:      "Panel de contexto",
    code_ctx_auto:           "auto",
    code_ctx_mode:           "Modo",
    code_ctx_agent:          "Agente",
    code_ctx_msgs_value:     "{user} usuario · {assistant} asistente",
    code_ctx_tokens_total:   "Tokens Total",
    code_ctx_created:        "Creado",
    code_ctx_activity:       "Actividad",
    code_project_fallback:   "proyecto {id}",
    code_pick_project_ph:    "Elegí un proyecto…",
    code_artifact_exit_ok:   "exit 0 — {ms}ms",
    code_artifact_exit_fail: "exit {code}{timeout}",
    code_artifact_timeout_suffix:" (timeout)",
    code_artifact_view_short:"Ver",
    code_artifact_edit_short:"Editar",
    code_artifact_exit_badge:"exit {code}",
    code_artifact_timeout:   "timeout",
    code_artifact_truncated: "truncado",
  },

  settings_ui: {
    bearer_label:            "Bearer",
    global_config_desc:      "Config general en ~/.apx/config.json. Editable por tabs; el JSON queda separado.",
    global_json_desc:        "Los secretos redacted no se sobrescriben.",
    save_json:               "Guardar JSON",
    expand_menu:             "Expandir menú",
    collapse_menu:           "Colapsar menú",
    documentation:           "Documentación",
    kind_personal:           "Personal",
    kind_company:            "Empresa",
    kind_app:                "App",
    kind_software:           "Software",
    kind_default:            "Default",
    kind_other:              "Otro",
    base_menu_view:          "Vista del menú Base (workspace general).",
    coming_soon:             "Próximamente",
    inspector_title:         "Skill Inspector (RAG por turno)",
    inspector_desc:          "Función experimental. Cuando está activa, el agente NO recibe la lista completa de skills en su prompt; en cada mensaje un RAG local decide qué skill(s) cargar — el cuerpo completo si hay match fuerte, una sugerencia si es medio, nada si no aplica. Se reevalúa en cada turno: una skill que dejó de ser relevante desaparece del contexto.",
    enable_inspector:        "Habilitar inspector",
    enable_inspector_hint:   "Off = comportamiento clásico (lista de slugs + sugerencia pasiva). On = el RAG decide por turno.",
    on:                      "On",
    off:                     "Off",
    index_count:             "Índice: {n} skills",
    not_indexed:             "sin indexar",
    dim:                     "dim {dim}",
    updated_at:              "actualizado {date}",
    reindex:                 "Reindexar",
    reindex_forced:          "Reindexar (forzado)",
    embedder_source:         "El embedder viene de Memoria (RAG). Local con Ollama, u offline si no hay proveedor configurado.",
    thresholds_title:        "Umbrales y límites",
    thresholds_desc:         "Ajustá qué tan agresivo es el inspector. Subir los umbrales = menos falsos positivos pero más riesgo de perderte una skill; bajarlos = al revés.",
    test_title:              "Probar (dry-run)",
    test_desc:               "Escribí un mensaje como lo haría un usuario y mirá qué skills cargaría/sugeriría el inspector — sin llamar al modelo. Fuerza el inspector aunque esté apagado arriba.",
    test_placeholder:        "ej.: necesito crear un video promocional con voz en off",
    test_btn:                "Probar",
    jit_empty_index:         "JIT (índice vacío)",
    loaded_label:            "Cargadas:",
    suggested_label:         "Sugeridas:",
    could_not_save:          "No se pudo guardar: {msg}",
    indexed_with:            "Indexado con {embedder} (dim {dim}): +{added} ~{refreshed} -{removed}.",
    index_failed:            "Falló el indexado: {msg}",
    dry_run_failed:          "Falló el dry-run: {msg}",
    knob_load_threshold:        "Umbral de carga",
    knob_load_threshold_hint:   "Similaridad mínima para inyectar el CUERPO de la skill (alto = más estricto).",
    knob_hint_threshold:        "Umbral de sugerencia",
    knob_hint_threshold_hint:   "Similaridad mínima para solo SUGERIR la skill (así el agente la carga si quiere).",
    knob_margin:                "Margen sobre la 2da",
    knob_margin_hint:           "La primera tiene que superar a la segunda por este margen para cargar su cuerpo (evita empates flojos).",
    knob_max_loaded:            "Máx. cuerpos cargados",
    knob_max_loaded_hint:       "Cuántas skills se inyectan completas por turno.",
    knob_max_hints:             "Máx. sugerencias",
    knob_max_hints_hint:        "Cuántas skills extra se nombran como sugerencia.",
    knob_prompt_floor:          "Largo mínimo del prompt",
    knob_prompt_floor_hint:     "Los mensajes más cortos que esto se ignoran (evita 'ok', 'hola').",
    knob_body_char_cap:         "Tope de chars del cuerpo",
    knob_body_char_cap_hint:    "Recorta los cuerpos largos para que no inflen el contexto.",
    cfg_overrides_label:        "Overrides",
    cfg_overrides_desc:         ".apc/config.json. Solo valores específicos del proyecto; vacío hereda del global/effective.",
    cfg_route_to_agent:         "Route to agent",
    cfg_super_agent_model:      "Modelo del super-agente",
    cfg_permission_mode:        "Permission mode",
    cfg_extra_prompt:           "Prompt extra",
    cfg_telegram_label:         "Telegram",
    cfg_chat_id:                "Chat ID",
    cfg_bot_token:              "Bot token",
    cfg_respond_with_engine:    "Responder con engine",
    cfg_engines_label:          "Engines",
    cfg_ollama_url:             "Ollama URL",
    cfg_anthropic_key:          "Anthropic API key",
    cfg_openai_key:             "OpenAI API key",
    cfg_groq_key:               "Groq API key",
    cfg_openrouter_key:         "OpenRouter API key",
    cfg_gemini_key:             "Gemini API key",
    cfg_project_label:          "Proyecto",
    cfg_project_desc:           ".apc/project.json. Metadata APC portable; sin secretos, sin runtime.",
    cfg_name:                   "Nombre",
    cfg_version:                "Versión",
    cfg_apc_spec:               "APC spec",
    cfg_apx_install:            "Estado de instalación APX",
    cfg_apx_storage_id:         "ID de storage APX",
  },

  skills_page: {
    title:               "Skills",
    desc:                "Activá o desactivá qué skills carga cada agente. Elegí el scope: el super-agent (global) o un proyecto puntual.",
    list_title:          "Skills instaladas",
    list_desc:           "Las privadas de APX están siempre activas y no se pueden tocar.",
    scope_label:         "Scope",
    scope_super_agent:   "Super-agent (global)",
    scope_hint:          "El super-agent usa el scope global. Cada proyecto puede sobrescribir skills de forma independiente.",
    count_label:         "{n} skills · {on} activas",
    empty:               "No hay skills. Creá una abajo o instalá con la CLI.",
    source_builtin:      "APX",
    source_global:       "Global",
    source_project:      "Proyecto",
    private_badge:       "Privada",
    private_hint:        "Skill interna de APX — siempre activa, no se puede desactivar ni borrar.",
    overridden_badge:    "Override",
    inherited_hint:      "Heredada del global",
    reset_to_global:     "Volver al global",
    on:                  "activa",
    off:                 "inactiva",
    toggle_failed:       "No se pudo cambiar el estado: {msg}",
    add_title:           "Agregar skill",
    add_desc:            "Crea una skill de usuario en ~/.apx/skills/<slug>/SKILL.md. Queda disponible para todos los scopes.",
    add_slug_label:      "Slug",
    add_slug_ph:         "mi-skill",
    add_desc_label:      "Descripción",
    add_desc_ph:         "Una línea que explique cuándo usarla",
    add_body_label:      "Cuerpo (Markdown)",
    add_body_ph:         "# Mi skill\n\nInstrucciones para el agente…",
    add_btn:             "Crear skill",
    created_ok:          "Skill \"{slug}\" creada.",
    create_failed:       "No se pudo crear: {msg}",
    delete_btn:          "Borrar",
    delete_confirm:      "¿Borrar la skill \"{slug}\"? No se puede deshacer.",
    deleted_ok:          "Skill \"{slug}\" borrada.",
    delete_failed:       "No se pudo borrar: {msg}",
    inspector_section_title: "Skill Inspector (RAG por turno)",
    inspector_section_desc:  "Config avanzada: RAG local que inyecta solo las skills que el mensaje necesita.",
    scope_ph:            "— elegir scope —",
    select_a_skill:      "Elegí una skill de la lista para ver su contenido.",
    added_by:            "Agregado por",
    activator:           "Activador",
    by_apx:              "APX (built-in)",
    by_you:              "Vos",
    activator_value:     "Coincidencia semántica (RAG)",
    tab_preview:         "Vista",
    tab_source:          "Fuente",
    add_menu:            "Agregar",
    add_online:          "Crear con el editor",
    add_online_hint:     "Escribí slug + descripción + contenido",
    add_zip:             "Subir .zip",
    add_zip_hint:        "Importar una skill empaquetada",
    add_repo:            "Desde repo git",
    add_repo_hint:       "Clonar desde una URL",
    create_dialog_title: "Crear skill",
    repo_dialog_title:   "Importar desde repo git",
    repo_url_label:      "URL del repo",
    repo_url_ph:         "https://github.com/usuario/mi-skill.git",
    repo_url_hint:       "El repo (o su subcarpeta) debe tener un SKILL.md.",
    import_btn:          "Importar",
    imported_ok:         "Skill \"{slug}\" importada.",
    import_failed:       "No se pudo importar: {msg}",
    cancel:              "Cancelar",
    manager_tab:         "Skills",
    rag_tab:             "Config (RAG)",
  },

  shared_ui: {
    skill_inspector_title: "Skill Inspector ({embedder}) eligió estas skills para este turno",
    tools_count:           "{n} tools",
    tool_read_file:        "Leer archivo",
    tool_write_file:       "Escribir archivo",
    tool_edit_file:        "Editar archivo",
    tool_list_files:       "Listar archivos",
    tool_search_files:     "Buscar en archivos",
    tool_search_messages:  "Buscar mensajes",
    tool_tail_messages:    "Últimos mensajes",
    tool_run_shell:        "Correr shell",
    tool_send_telegram:    "Enviar Telegram",
    tool_call_agent:       "Llamar agente",
    tool_call_mcp:         "Llamar MCP",
    tool_call_runtime:     "Llamar runtime",
    tool_create_task:      "Crear task",
    dedup:                 "dedup",
    args:                  "args",
    result:                "result",
    auto:                  "Auto",
    auto_router:           "Auto (decide el router)",
    model_filter_ph:       "filtrar o escribir modelo…",
    loading_models:        "cargando modelos…",
    use_value:             "usar “{value}”",
    model_combobox_ph:     "elegí o escribí un modelo…",
    search_variable_ph:    "buscar variable…",
    no_matches:            "sin coincidencias",
    create_variable:       "Crear nueva variable…",
    kv_key_ph:             "CLAVE",
    kv_value_ph:           "valor",
    remove_row:            "quitar fila",
    add_row:               "Agregar fila",
    err_chat_failed:       "Falló el chat.",
    err_stream_failed:     "Falló el stream.",
    err_load_conversation: "No se pudo cargar la conversación.",
    err_stream:            "Error de stream.",
  },
  integrations: {
    title:               "Integrations",
    description:         "Plugins y tools disponibles para este proyecto",
    tab_plugins:         "Plugins",
    tab_tools:           "Tools",
    scope_label:         "Ámbito:",
    scope_project:       "Este proyecto",
    scope_global:        "Global (default)",
    plugins_hint:        "Plugins de canal y servicio instalables por proyecto. Se guardan en el ámbito seleccionado arriba.",
    more_soon:           "Más plugins próximamente…",
    tools_hint:          "Tools que los plugins conectados exponen a los agentes de este proyecto.",
    tools_empty:         "No hay tools de integraciones. Conectá un plugin para habilitarlas.",
    tool_active:         "activo",
    tool_inactive:       "inactivo",
    status_active:       "Activo",
    status_error:        "Error",
    status_unconfigured: "No configurado",
    connected:           "Conectado",
    connect:             "Conectar",
    deactivate:          "Desactivar",
    saving:              "Guardando...",
    validating:          "Validando...",
    verifying:           "Verificando token...",
    confirm:             "Confirmar",
    select_placeholder:  "Seleccionar...",
    reveal:              "Ver",
    hide:                "Ocultar",
    credentials:         "Credenciales {name}",
    coming_soon:         "Próximamente",
    coming_soon_body:    "Este plugin está declarado en el catálogo pero todavía no está conectable en APX. Se va a portar de forma nativa en una próxima iteración.",
    tools_for_agents:    "Tools para agentes",
    tools_available_note: "Disponibles para los agentes que las tengan permitidas, o vía discover_tools.",
    err_connect:         "Error al conectar",
    err_generic:         "Ocurrió un error",
    asana: {
      select_label: "Seleccioná el workspace a usar",
      connected: { user_name: "Conectado como", user_email: "Email", workspace_name: "Workspace" },
      fields: {
        personal_access_token: {
          label: "Personal Access Token",
          help_label: "¿Cómo obtener el token?",
          help_steps: "Abrí app.asana.com/0/my-apps en el navegador.\nBajá hasta la sección \"Personal access tokens\" (no tus apps OAuth).\nHacé clic en \"+ New access token\".\nDale un nombre y confirmá.\nCopiá el token completo — empieza con \"1/...\" y tiene un \":\" en el medio.\nPegalo en el campo de abajo.",
        },
      },
    },
    github: {
      connected: { user_login: "Conectado como", user_name: "Nombre" },
      fields: {
        token: {
          label: "Personal Access Token",
          help_label: "¿Cómo obtener el token?",
          help_steps: "Abrí github.com/settings/tokens.\nGenerá un token (classic o fine-grained) con scope \"repo\".\nCopiá el token — empieza con ghp_ o github_pat_.\nPegalo en el campo de abajo.",
        },
      },
    },
  },
} as const;

export type EsStrings = typeof es;
